import { formatNumberAsThousands } from 'utils/priceHelpers'

import styles from './InsightsTooltip.module.scss'

const TooltipRow = props => {
  const { fill, stroke, value, name, unit, fontSize, valueFormatter } = props

  return (
    <div className={styles.tooltipRow} style={{ fontSize }}>
      <svg width="8" height="8">
        <circle cx="4" cy="4" r="4" fill={stroke || fill}></circle>
      </svg>
      <span className={styles.tooltipLabel}>{name}</span> {unit === '$' ? unit : ''}
      <span className={styles.tooltipValue}>
        {valueFormatter(value)} {unit !== '$' ? unit : ''}
      </span>
    </div>
  )
}

function formatName(dataKey, firstYear, secondYear) {
  if (dataKey === 'firstYear') {
    return firstYear
  }

  if (dataKey === 'secondYear') {
    return secondYear
  }
}

const InsightsTooltip = ({
  label,
  payload,
  fontSize = 12,
  labelFormatter,
  valueFormatter = formatNumberAsThousands,
  firstYear,
  secondYear,
  dataTitle
}) => {
  return (
    <div className={styles.container}>
      <div className={styles.tooltipTitle}>
        {labelFormatter ? labelFormatter(label) : label} {dataTitle}
      </div>
      {payload.map((p, i) => (
        <TooltipRow
          {...p}
          key={`${p.name}${i}`}
          fontSize={fontSize}
          name={formatName(p.name, firstYear, secondYear)}
          valueFormatter={valueFormatter}
        />
      ))}
    </div>
  )
}

export default InsightsTooltip
